import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { Fragment as p } from "react";
const i = ({ text: t }) => t.split(`
`).map((m, r, o) => /* @__PURE__ */ s(p, { children: [
  m,
  r < o.length - 1 && /* @__PURE__ */ e("br", {})
] }, r));
export {
  i as T
};
